import { useEffect, useState } from "react";
import { Badge } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import { apiClient } from "../../../services/api/apiClient";

/**
 * PR4 — Icon + badge para la entrada de menú "Confirmar variedad".
 * Hace polling cada 60s al endpoint `/count/` (extra-light, sólo
 * devuelve un número) para no hammer-ear con la list completa.
 *
 * Cuando el contador es 0, el badge se oculta automáticamente
 * (`showZero={false}`) y queda el icono limpio.
 */
export const VarietyConfirmationsMenuBadge = () => {
  const [count, setCount] = useState<number>(0);

  useEffect(() => {
    let cancelled = false;
    const fetchCount = async () => {
      try {
        const r = await apiClient.get<{ count: number }>(
          "/admin/variety-confirmations/count/",
        );
        if (!cancelled) setCount(r.data?.count ?? 0);
      } catch {
        // Silenciamos errores — el badge es informativo.
      }
    };
    void fetchCount();
    const id = window.setInterval(fetchCount, 60_000);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, []);

  return (
    <Badge count={count} size="small" offset={[6, -2]}>
      <ExclamationCircleOutlined />
    </Badge>
  );
};

export default VarietyConfirmationsMenuBadge;
